import { createWidget } from "@opendash/plugin-monitoring";
import React from "react";
import image from "./image";
import { ConfigInterface } from "./types";

export default createWidget<ConfigInterface>({
  type: "opendash-widget-hc-pivot-oi",
  meta: {},
  displayComponent: React.lazy(() => import("./component")),
  settingsComponent: React.lazy(() => import("./settings")),

  dataItems: {
    select: "dimension",
    min: 1,
    types: ["Number", "String", "Boolean"],
  },

  dataFetching: {
    history: true,
    historyRequired: true,
    aggregation: false,
    aggregationRequired: false,
  },

  dataExplorer: {
    title: "highcharts:explorer.pivotOI.title",
    description: "highcharts:explorer.pivotOI.description",
    icon: "fa:fa-calculator",
    config: {},
  },

  presets: [
    {
      label: "highcharts:explorer.pivotOI.title",
      description: "highcharts:explorer.pivotOI.desciption",
      layout: [5, 12],
      tags: ["pivot"],
      imageLink: image,
      widget: {
        config: {
          filters: {},
          rows: [],
          cols: [],
          values: ["max", "second"],
          visualizationOptions: {
            heatmap: false,
            zoom: 1,
            columnSort: "asc",
            valueSort: "desc",
          },
        },
      },
    },
  ],
});
